"use strict";

var _toConsumableArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _emptyProps = require("./emptyProps");
function mergeProps(props) {
  var filteredProps = props.filter(_emptyProps.isNotEmpty);
  if (filteredProps.length) {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(filteredProps)));
  }
  return _emptyProps.emptyProps;
}
var _default = mergeProps;
exports.default = _default;